// test1251
(1251 && 0);
